import { flatten, flow } from "lodash";
import { compareValues } from "./common";
/** Function for sorting arrays of objects.
 * @param items An array of objects which should be sorted.
 * @param sortBy.property Initial object key which should be used for sorting.
 * @param sortBy.reverse Whether or not should sort be in reverse.
 * @param specialCases Object containing custom sort functions for desired keys. Ensure that it doesn't change on every render since it is a hook dependency.
 */
export function sortItems(items, sortBy, specialCases) {
    /** Check if sort by property belongs to Type object */
    function isKey(value, item) {
        const allowedKeys = Object.keys(item);
        return allowedKeys.indexOf(value.toString()) !== -1;
    }
    return [...items].sort((first, second) => {
        var _a, _b;
        if (specialCases !== undefined &&
            specialCases[sortBy.property] !== undefined) {
            /** Typescript cannot figure out that specialCases[sortBy.property] cannot be undefined inside this if */
            return ((_b = (_a = specialCases[sortBy.property]) === null || _a === void 0 ? void 0 : _a.call(specialCases, first, second, sortBy.reverse)) !== null && _b !== void 0 ? _b : 0);
        }
        if (isKey(sortBy.property, first) && isKey(sortBy.property, second)) {
            if (typeof first[sortBy.property] === "boolean" &&
                typeof second[sortBy.property] === "boolean")
                return compareValues(first[sortBy.property], second[sortBy.property], sortBy.reverse);
            else if (typeof first[sortBy.property] === "string" &&
                typeof second[sortBy.property] === "string")
                return compareValues(first[sortBy.property], second[sortBy.property], sortBy.reverse);
            else if (typeof first[sortBy.property] === "number" &&
                typeof second[sortBy.property] === "number")
                return compareValues(first[sortBy.property], second[sortBy.property], sortBy.reverse);
            else if (typeof first[sortBy.property] === "bigint" &&
                typeof second[sortBy.property] === "bigint")
                return compareValues(first[sortBy.property], second[sortBy.property], sortBy.reverse);
        }
        else {
            /** All extra keys should have a callback defined. */
            if (!PRODUCTION) {
                // eslint-disable-next-line no-console
                console.warn("sort has extra keys which do not define a sort function!");
            }
        }
        return 0;
    });
}
export const prettyJoin = (joinArray, delimiter = ", ", finalDelimiter = " & ") => {
    // takes an array of strings and return a prettier version in a string :)
    // ['org', 'group', 'security']
    // 'org, group & security'
    switch (joinArray.length) {
        case 0:
            return "";
        case 1:
            return joinArray.join();
        case 2:
            return joinArray.join(finalDelimiter);
        default:
            return `${joinArray
                .slice(0, joinArray.length - 1)
                .join(delimiter)}${finalDelimiter}${joinArray[joinArray.length - 1]}`;
    }
};
const dedupe = (input) => input.filter((value, pos, arr) => arr.indexOf(value) === pos);
export const flattenDedupe = flow([flatten, dedupe]);
//# sourceMappingURL=arrays.js.map